import {Validation} from "@/data/Validation";

export type DeliveryArea = {
    id: number,
    postalCode: string,
    deliveryTimeMinutes: number,
    minimumOrderAmount: number,
    deliveryFee: number,
};

export type UpdateDeliveryAreaFields = {
    postalCode: string,
    deliveryTimeMinutes: number,
    minimumOrderAmount: number,
    deliveryFee: number,
};

export type DeliveryAreaFormValues = {
    postalCode: string,
    deliveryTimeMinutes: number,
    minimumOrderAmount: string,
    deliveryFee: string,
};

export const deliveryAreaFormValuesFormValidation: Validation<DeliveryAreaFormValues> = {
    postalCode: {
        required: true,
        minLength: 4,
        maxLength: 4,
    },
    deliveryTimeMinutes: {
        required: true,
        min: 1,
        max: 10000,
    },
    minimumOrderAmount: {
        required: true,
        min: 0,
        max: 10000,
    },
    deliveryFee: {
        required: true,
        min: 0,
        max: 10000,
    },
}